const FETCH_USER_NOTIFICATIONS_SUBMIT = (state) => {
  // console.log('FETCH_USER_NOTIFICATIONS_SUBMIT')
  state.fetchNotificationsInProcess = true
  state.fetchNotificationsError = false
}

const FETCH_USER_NOTIFICATIONS_RESPONSE = (state, data) => {
  // console.log('FETCH_USER_NOTIFICATIONS_RESPONSE', data)
  state.notifications = data
  state.fetchNotificationsInProcess = false
}

const FETCH_USER_NOTIFICATIONS_ERROR_RESPONSE = (state, data) => {
  state.fetchNotificationsError = true
  state.fetchNotificationsInProcess = false
}

const SET_USER_NOTIFICATIONS_SUBMIT = (state) => {
  state.setNotificationsInProcess = true
  state.setNotificationsError = false
}

const SET_USER_NOTIFICATIONS_SUCCESS = (state, data) => {
  state.setNotificationsInProcess = false
}

const SET_USER_NOTIFICATIONS_ERROR_RESPONSE = (state, data) => {
  state.setNotificationsError = true
  state.setNotificationsInProcess = false
}

export default {
  FETCH_USER_NOTIFICATIONS_SUBMIT,
  FETCH_USER_NOTIFICATIONS_RESPONSE,
  FETCH_USER_NOTIFICATIONS_ERROR_RESPONSE,
  SET_USER_NOTIFICATIONS_SUBMIT,
  SET_USER_NOTIFICATIONS_SUCCESS,
  SET_USER_NOTIFICATIONS_ERROR_RESPONSE
}



// WEBPACK FOOTER //
// ./src/store/modules/user/notifications/mutations.js